import rest from "@/api/rest";
import environment from "@/environment";
import { useAuth } from "@/stores/auth.store";
import { createApiClient } from "./client";
import { handleAuth } from "./handle-auth";

export {
  blobToJSON,
  handleStream,
  readableStreamToJSON,
  serializeParams,
  throwBlobErrorAsJson,
} from "./helpers";
export {
  API_ERROR_HANDLED,
  ApiError,
  isApiError,
  isApiErrorHandled,
  isCancelError,
  markApiErrorHandled,
} from "./types";
export type { ApiResponse, RequestConfig } from "./types";

export const api = createApiClient(environment.VITE_BACKEND_ADDRESS);

// Latency simulation for development (helps visualize loading states)
if (import.meta.env.DEV) {
  const simulatedLatency = environment.VITE_SIMULATED_LATENCY;

  if (simulatedLatency > 0) {
    api.useRequestMiddleware(async (config) => {
      await new Promise((resolve) => setTimeout(resolve, simulatedLatency));
      return config;
    });

    console.warn(`[DEV] Simulating network latency: ${simulatedLatency}ms on all API requests`);
  }
}

export const { scheduleProactiveRefresh, clearProactiveRefresh } = handleAuth(api, {
  logoutHandler: () => void useAuth().logout(),
  refreshTokenHandler: () => rest.auth.refresh(),
});
